// @flow
import React, { Component } from 'react';
import capitalize from 'capitalize';
import { Table, thead, th, tr } from 'react-bootstrap';
// import zeroFill from 'zero-fill';
import FontAwesome from 'react-fontawesome';
import moment from 'moment';

import GroupEvents from './util/GroupEvents';
import MedicationRow from './components/MedicationRow/MedicationRow';
import locale from '../../../../locales/index';
import style from './style';
import api from '../../../../services/api';

class MedicationList extends Component<Object, {
  medication: Array<Object>,
  users: Array<Object>,
  loading: boolean,
  intlId?: number,
  lastSync: string,
}> {
  constructor(props: Object) {
    super(props);

    this.state = {
      medication: [],
      users: [],
      loading: false,
      lastSync: moment().clone().format('HH:mm:ss'),
    };
  }

  componentWillMount() {
    api.users.getList((res) => { this.onUsersLoaded(res); });
  }

  componentWillUnmount() {
    clearTimeout(this.state.intlId);
  }

  onUsersLoaded(list: Array<Object>) {
    this.setState({
      users: list,
      loading: true,
      lastSync: moment().clone().format('HH:mm:ss'),
    });

    const endDate = moment().clone().toISOString();
    const startDate = moment().clone().subtract(3, 'days').toISOString();

    api.telemetry.medication({ startDate, endDate, page: 1, ownerId: undefined }, (res) => {
      this.onMedicationLoaded(res);
    });
  }

  onMedicationLoaded(list: Array<Object>) {
    const intlId = setTimeout(() => {
      this.setState({
        loading: true,
      });

      const endDate = moment().clone().toISOString();
      const startDate = moment().clone().subtract(3, 'days').toISOString();

      api.telemetry.medication({ startDate, endDate, page: 1, ownerId: undefined }, (res) => {
        this.onMedicationLoaded(res);
      });
    }, 30 * 1000);

    this.setState({
      loading: false,
      medication: list,
      intlId,
    });
  }

  generateListContent(): Array<MedicationRow> {
    const groups = GroupEvents(this.state.medication);

    const rows = groups.map((group) => {
      const owner = this.state.users.find(el => el.id === group.ownerId);
      // const time = new Date(group.lastEventTime);
      const time = moment(group.lastEventTime).clone();

      return (<MedicationRow
        name={capitalize.words(owner ? `${owner.profile.name.givenName} ${owner.profile.name.familyName}` : group.ownerId)}
        amount={group.medication.amount}
        medication={capitalize.words(group.medication.name)}
        date={`${time.format('DD/MM/YYYY')}`}
        time={`${time.format('HH:mm')}`}
        image={owner ? owner.profile.image.url : ''}
        state={group.taken}
        key={group.events[0].id}
        events={group.events.length}
      />);
    });

    return rows;
  }

  render() {
    return (
      <div>
        {this.state.loading ?
          <div><h5 style={{ textAlign: 'right' }}><FontAwesome name="refresh" spin /> {locale.loading}...</h5></div> :
          <div><h5 style={{ textAlign: 'right' }}><FontAwesome name="refresh" /> {locale.lastSynced}: {this.state.lastSync} </h5></div>
        }
        <Table responsive hover style={style.tableStyle}>
          <thead>
            <tr>
              <th>#</th>
              <th>{locale.name}</th>
              <th>{locale.medication}</th>
              <th>{locale.amount}</th>
              <th>{locale.notifications}</th>
              <th>{locale.date}</th>
              <th>{locale.time}</th>
              <th>{locale.confirmed}</th>
            </tr>
          </thead>
          <tbody>
            {this.generateListContent()}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default MedicationList;



// WEBPACK FOOTER //
// ./src/scenes/Medication/components/MedicationList/MedicationList.js